import Http from '@/services/http';
import {
  AttentionMapListRequest,
  AttentionMapListResponse,
  AttentionMapAlarmsRequest,
  AttentionMapAlarmsResponse,
} from 'sigma-mappings';

const urls = {
  list: '/Alarme/mapa-atencao',
  alarms: '/Alarme/mapa-atencao/alarmes',
};

export default {
  /**
   * Obtém as instalações do escopo com seus ativos, alarme principal e contagem
   * de status de comunicação, para o Mapa de Atenção dos Ativos.
   *
   * @param {Object} params Escopo e paginação.
   */
  getList(params) {
    const http = new Http();
    const mappedParams = new AttentionMapListRequest(params);

    return http.post(urls.list, mappedParams)
      .then(({ data }) => new AttentionMapListResponse(data));
  },
  /**
   * Obtém os Alarmes em Aberto do recorte, do mais recente para o mais antigo,
   * para a lista de Últimos Alarmes e Avisos ao lado do mapa.
   *
   * Endpoint irmão do `mapa-atencao`, e não o `/alarme/ultimos` do Dashboard: as
   * duas telas pedem coisas diferentes o bastante para que um contrato só
   * significasse reescrever o do Dashboard. Ver
   * docs/pedidos/ultimos-alarmes-escopo-do-mapa.md
   *
   * @param {Object} params Escopo, recorte, filtros e paginação.
   */
  getAlarms(params) {
    const http = new Http();
    const mappedParams = new AttentionMapAlarmsRequest(params);

    return http.post(urls.alarms, mappedParams)
      .then(({ data }) => new AttentionMapAlarmsResponse(data));
  },
};
